// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"SkeletonLoader_skeletonContainer__fAN4S","skeletonMonth":"SkeletonLoader_skeletonMonth__kReRH","skeletonCard":"SkeletonLoader_skeletonCard__O8En3"};